import React from "react";
import Header from "../../../layouts/AuthLayout/header/header";
import BannerImagesSection from "./banner-images-section";

export default function BannerImagesPage() {
  return (
    <>
      <Header />
      <BannerImagesSection />
    </>
  );
}
